import React from 'react'
import Markdown from '../Markdown'
import { toSlug } from 'ak-react-utils'
import { itemTypeByDisplayMode } from '../ItemTypes'

const SectionPlain = ({ section }) => {
  const renderableItems = section.items?.sort((a,b) => a.position - b.position).map((item,i) => {

    const SpecificItem = itemTypeByDisplayMode(item)

    return (
      <div className='mb-4' key={i}>
        <SpecificItem item={ item } />
      </div>
    )

  })

  return (
    <section className='section-plain'>
      <h2 id={ toSlug(section.headline) } className='section-headline'>
        { section.headline }
      </h2>

      {section.body && (
        <div className='section-body'>
          <Markdown>
            { section.body }
          </Markdown>
        </div>
      )}

      {renderableItems && (
        <div className='section-items'>
          { renderableItems }
        </div>
      )}
    </section>
  )
}

export default SectionPlain
